import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Modal, Spin } from "antd";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { useStores } from "../../../store/stores.js";
import { __ } from "../../../utils/i18n.js";
import { TcfVendorConfigurationForm } from "../cookies/tcf/form.js";
const BlockerFormNoticeNoneExistingTcfVendors = observer(({ nonExistingTcfVendors, onCreated })=>{
    const [openId, setOpenId] = useState();
    const { tcfStore } = useStores();
    const { vendorListVersion, vendors } = tcfStore;
    // Created vendors to hide them from the list
    const [created, setCreated] = useState([]);
    const useNoneExistingTcfVendors = (nonExistingTcfVendors || []).filter(({ vendorId })=>created.indexOf(vendorId) === -1);
    // Initially fetch all vendors so we can create the modals correctly
    useEffect(()=>{
        if (nonExistingTcfVendors.length > 0 && !vendorListVersion) {
            tcfStore.fetchVendors();
        }
    }, [
        nonExistingTcfVendors,
        vendorListVersion
    ]);
    if (!vendorListVersion && nonExistingTcfVendors.length > 0) {
        return /*#__PURE__*/ _jsx(Spin, {
            spinning: true
        });
    }
    // Create modal windows as they should always be available in React tree (avoid "Can't perform a React state update on an unmounted component")
    const modalWindows = nonExistingTcfVendors?.map(({ vendorId })=>{
        return /*#__PURE__*/ _jsx(Modal, {
            open: openId === vendorId,
            title: __("Add TCF vendor configuration"),
            width: "calc(100% - 50px)",
            bodyStyle: {
                paddingBottom: 0
            },
            footer: null,
            onCancel: ()=>setOpenId(undefined),
            children: /*#__PURE__*/ _jsx(TcfVendorConfigurationForm, {
                navigateAfterCreation: false,
                scrollToTop: false,
                vendor: vendors.get(`${vendorId}`),
                onCreated: (model)=>{
                    setOpenId(undefined);
                    setCreated([
                        ...created,
                        openId
                    ]);
                    onCreated(model);
                }
            })
        }, vendorId);
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            modalWindows,
            useNoneExistingTcfVendors.length === 0 ? null : /*#__PURE__*/ _jsxs("div", {
                className: "notice notice-warning below-h2 notice-alt",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        children: __("Some TCF vendors from the template could not be found. Please select (or create if not already exist) the following TCF vendors:", useNoneExistingTcfVendors.join(", "))
                    }),
                    /*#__PURE__*/ _jsx("ul", {
                        style: {
                            margin: "0 0 10px"
                        },
                        children: useNoneExistingTcfVendors.map(({ vendorId, createAdNetwork })=>/*#__PURE__*/ _jsxs("li", {
                                children: [
                                    /*#__PURE__*/ _jsx("strong", {
                                        children: vendors.get(`${vendorId}`).data.name
                                    }),
                                    "\xa0•\xa0",
                                    /*#__PURE__*/ _jsx("a", {
                                        onClick: (e)=>{
                                            if (createAdNetwork) {
                                                window.location.href = `#/cookies/tcf-vendors/new?adNetwork=${encodeURIComponent(createAdNetwork)}`;
                                            } else {
                                                setOpenId(vendorId);
                                            }
                                            e.preventDefault();
                                        },
                                        children: __("Create now")
                                    })
                                ]
                            }, vendorId))
                    })
                ]
            })
        ]
    });
});
export { BlockerFormNoticeNoneExistingTcfVendors };
